// 工具
import tool from '@/views/tool'
export default {
  path: '/tool',
  name: 'tool',
  component: tool,
  meta: {
    keepAlive: true,
    title: '工具',
    // code: 'page:report',
    activeName: '/tool',
    permission: 'tools',
    name: 'fishReport'
  },
  children: [
    {
      path: 'fishReport',
      name: 'fishReport',
      component: resolve => require(['@/views/report/fishReport'], resolve),
      meta: {
        keepAlive: true,
        title: '飞鱼线索',
        iconName: 'icon-xiansuo-daoyinxuanzhong',
        permission: 'feiyuClueReport'
      }
    },
    {
      path: 'oceanLog',
      name: 'oceanLog',
      component: resolve => require(['@/views/monitor/oceanLog'], resolve),
      meta: {
        keepAlive: true,
        title: '巨量日志',
        iconName: 'icon-juliangrizhi',
        permission: 'accountLog'
      }
    },
    {
      path: 'commentManager',
      name: 'commentManager',
      component: resolve => require(['@/views/tool/comment'], resolve),
      meta: {
        keepAlive: true,
        title: '评论管理',
        iconName: 'icon-pinglunguanli',
        // permission: 'accountLog',
        subMenuShow: false
      },
      subMenu: [
        {
          name: 'commentContent',
          title: '评论内容'
        },
        {
          name: 'commonWords',
          title: '常用语'
        },
        {
          name: 'shieldingWords',
          title: '屏蔽词'
        },
        {
          name: 'shieldUsers',
          title: '屏蔽用户'
        }
      ],
      children: [
        {
          path: 'commentContent',
          name: 'commentContent',
          component: resolve => require(['@/views/tool/comment-content'], resolve),
          meta: {
            parents: 'commentManager',
            keepAlive: true,
            title: '评论内容'
          }
        },
        {
          path: 'commonWords',
          name: 'commonWords',
          component: resolve => require(['@/views/tool/common-words'], resolve),
          meta: {
            parents: 'commentManager',
            keepAlive: true,
            title: '常用语'
          }
        },
        {
          path: 'shieldingWords',
          name: 'shieldingWords',
          component: resolve => require(['@/views/tool/shielding-words'], resolve),
          meta: {
            parents: 'commentManager',
            keepAlive: true,
            title: '屏蔽词'
          }
        },
        {
          path: 'shieldUsers',
          name: 'shieldUsers',
          component: resolve => require(['@/views/tool/shield-users'], resolve),
          meta: {
            parents: 'commentManager',
            keepAlive: true,
            title: '屏蔽用户'
          }
        }
      ]
    },
    {
      path: 'star',
      name: 'star',
      component: resolve => require(['@/views/tool/star'], resolve),
      meta: {
        keepAlive: true,
        title: '星图',
        iconName: 'icon-star',
        permission: 'star',
        subMenuShow: false
      },
      subMenu: [
        {
          name: 'orderList',
          title: '订单详情'
        },
        {
          name: 'orderReport',
          title: '数据报表'
        }
      ],
      children: [
        {
          path: 'orderList',
          name: 'orderList',
          component: resolve => require(['@/views/tool/star/order-list'], resolve),
          meta: {
            parents: 'star',
            keepAlive: true,
            permission: 'star:order:getStarDemandOrderList',
            title: '订单详情'
          }
        },
        {
          path: 'orderReport',
          name: 'orderReport',
          component: resolve => require(['@/views/tool/star/order-report'], resolve),
          meta: {
            parents: 'star',
            keepAlive: true,
            permission: 'star:report:list',
            title: '数据报表'
          }
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/modules/tool.js